import { EditShopperButtons } from './edit-shopper-buttons';
import { PublishNewShopperButton } from './publish-new-shopper-button';

export const DrawerFooter = ({ isReadonly, onSaveShopper, shopperForPost, unsavedShopperServices }) => {
  const { serviceCollectionGuid } = shopperForPost;
  const isNewRateShopper = !serviceCollectionGuid || serviceCollectionGuid === '';
  const isPublishDisabled = isReadonly || !shopperForPost?.name?.length;
  return isNewRateShopper ? (
    <PublishNewShopperButton
      disabled={isPublishDisabled}
      onSaveShopper={onSaveShopper}
      shopper={shopperForPost}
      unsavedServices={unsavedShopperServices}
    />
  ) : (
    <EditShopperButtons
      disabled={isReadonly}
      onSaveShopper={onSaveShopper}
      shopper={shopperForPost}
      unsavedServices={unsavedShopperServices}
    />
  );
};
